import {useStyles} from './../../../../shared/hooks/styles';

const CELL_SPACING = 40;

export const GetStyles = () => {
  return useStyles(({theme}) => ({
    container: {
      width: 'auto',
      maxWidth: 900,
    },
    noData: {
      paddingVertical: 24,
      color: theme.color.gray500,
    },
    headCell: {
      ...theme.fonts.body,
      color: theme.color.gray500,
      marginRight: CELL_SPACING,
    },
    cell: {
      marginRight: CELL_SPACING,
    },
    colDescription: {
      flexBasis: 417,
      maxWidth: 417,
    },
    colAmount: {
      flexBasis: 203,
      maxWidth: 203,
    },
    colDate: {
      flexBasis: 114,
      flexGrow: 1,
    },
  }));
};
